import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import I18n from 'I18n';
import { useNavigationComponent } from 'navigation-components/application/hooks';
import { globalSearchComponentDef } from 'navigation-components/config';
import { jsx as _jsx } from "react/jsx-runtime";
export const SearchButton = () => {
  const {
    setProps,
    show
  } = useNavigationComponent({
    componentDef: globalSearchComponentDef
  });
  const openSearchForSettings = async () => {
    await setProps({
      searchFilters: 'SETTINGS',
      searchPreFiltered: 'true'
    });
    await show();
  };
  const handleSearchClick = () => {
    openSearchForSettings().catch(console.error);
  };
  return /*#__PURE__*/_jsx(UIIconButton, {
    use: "link",
    onClick: handleSearchClick,
    tooltip: I18n.text('settings-ui-nav.searchButtonLabel'),
    children: /*#__PURE__*/_jsx(UIIcon, {
      name: "search"
    })
  });
};